import { useState } from 'react'
import { Typography, Divider } from "@mui/material"
import { useDispatch, Actions, useSelector, useTrigger, Triggers } from "../../stores/dashboard.store"
import { DashboardBody, DashboardHeader } from '../dashboard-container'
import { useSnackbar } from '../snackbar/snackbar'
import Button from '../nura/button/button'
import { getMeSettings, putUserSettings } from "../../api-client/data"
import useFetch from "../../hooks/useFetch"
import styles from './styles.module.css'
import { createDeveloperAccount } from '../../api-client/data'

export default () => {
    const { user } = useSelector()
    const settings = useFetch(getMeSettings)
    const [isLoading, setIsLoading] = useState(false)
    const refreshUserInfo = useTrigger(Triggers.RefreshUserInfo)    

    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()

    const saveSettings = async (e) => {
        e.preventDefault()
        dispatch(Actions.SetIndeterminate, true)
        try {
            const formData = new FormData(e.target)

            await putUserSettings({
                ...settings.data,
                email: formData.get('email'),
            })
            enqueueSnackbar("Settings saved", { variant: "success" })
        } catch {
            enqueueSnackbar("Settings could not be saved, try again later", { variant: "error" })
        }
        dispatch(Actions.SetIndeterminate, false)

        settings.refresh()
    }

    const onCreateDeveloperAccount = async () => {
        setIsLoading(true)

        await createDeveloperAccount()
        await refreshUserInfo()

        setIsLoading(false)
    }

    return (
        <>
            <div className={styles.dashboardContent}>
                <DashboardHeader title="General Settings">                    
                </DashboardHeader>
                <DashboardBody loading={settings.loading || isLoading}>
                    <div style={{ paddingBottom: 10 }}>
                        <Typography variant="h6" style={{ flex: 1, color: 'var(--text-primary)' }}>Email</Typography>
                        <Divider sx={{ borderColor: `var(--border-secondary)` }} />
                    </div>
                    <div>
                        <form style={{ margin: "4px" }} onSubmit={saveSettings}>
                            <div className={styles.actionTitle}>Primary Email</div>
                            <input
                                style={{ color: 'var(--text-primary)', width: '70%', borderRadius: 5, border: '1px solid var(--border-secondary)', backgroundColor: 'var(--background-secondary)', fontSize: '15px' }}
                                name="email"
                                defaultValue={user?.email}
                                value={user?.email}
                                readOnly
                            />

                            {/* <div style={{ marginTop: 10 }}>
                                <Button type="submit" size="normal" variant="primary">Save</Button>
                            </div> */}
                        </form>
                    </div>

                    {
                        !user?.is_developer && (
                            <>
                                <div style={{ paddingBottom: 10, marginTop: 20 }}>
                                    <Typography variant="h6" style={{ flex: 1, color: 'var(--text-primary)' }}>Developer</Typography>
                                    <Divider sx={{ borderColor: `var(--border-secondary)` }} />
                                </div>

                                <div>
                                    <div style={{ color: 'var(--text-primary)', marginBottom: 10 }}>
                                        <div>
                                            You do not have a developer account, would you like to create one?
                                        </div>
                                        <div>
                                            This will enable developer features for your account, at no additional cost.
                                        </div>
                                    </div>

                                    <Button variant="outline" onClick={onCreateDeveloperAccount}>Create Developer Account</Button>
                                </div>
                            </>
                        )
                    }
                </DashboardBody>
            </div>
        </>
    )
}